






























































import { Vue, Component, Watch } from "vue-property-decorator";
import {
  Product,
  WarehouseItem,
  PrintAreaCustomization,
  ProductCustomization,
} from "@/models";
import CustomizationList from "@/components/Customizer/Customization/List.vue";
import { isMobile } from "@/helpers/mediaQueryHelper";
import { addToCart } from "@/services/woocommerceService";
import VisualCustomization from "@/components/PrintAreaCustomization/Wrapper.vue";
import { customizationStore,currentUserStore } from "@/store/typed";
import Preview from "@/components/Customizer/ThreeCanvas.vue";
import { CustomizationMode } from "@/models/types";
import { showError } from "@/helpers/Toast";
import DotLoader from "@/components/Common/DotLoader.vue";
import { CART_SLUG,STORE_URL } from "@/constants";
import { easync } from "@/helpers/http";

@Component({
  components: {
    Preview,
    CustomizationList,
    VisualCustomization,
    DotLoader,
  },
})
export default class Container extends Vue {
  private previewLoading = false;
  private previewAutorotating = true;

  get isMobile(): boolean {
    return isMobile((this as any).$mq);
  }

  get product(): Product {
    return customizationStore.product;
  }

  get productCustomization(): ProductCustomization {
    return customizationStore.productCustomization;
  }

  get printAreaCustomization(): PrintAreaCustomization {
    return customizationStore.currentPrintAreaCustomization;
  }

  get customizationListStyle() {
    return { "padding-top": "15%", height: `${window.innerHeight}px` };
  }

  get warehouseItem(): WarehouseItem {
    return customizationStore.warehouseItem;
  }

  @Watch('printAreaCustomization')
  onPrintAreaCustomizationChanged(){
    customizationStore.updatedLastCustomizedAt();
  }

  get assetUrl(): string {
    return (
      this.warehouseItem?.warehouseItemArtifact?.artifact?.asset?.url || null
    );
  }

  get warehouseItemArtifact() {
    return this.warehouseItem?.warehouseItemArtifact;
  }

  get mode() {
    return customizationStore.mode;
  }

  set mode(mode: CustomizationMode) {
    customizationStore.setMode(mode);
  }

  onPreviewLoaded() {
    this.previewLoading = false;
  }

  toggleAutoRotate() {
    this.previewAutorotating = !this.previewAutorotating;
    (this.$refs.preview as any).toggleAutorotate(this.previewAutorotating);
  }

  get objectConfig() {
    const wia = this.warehouseItem?.warehouseItemArtifact;
    return {
      zoom: wia.zoom || 5,
      rotationX: wia.rotationX || 0,
      rotationY: wia.rotationY || 0,
      rotationZ: wia.rotationZ || 0,
    };
  }

  onPreview(mode: any) {
    this.previewLoading = mode === "3d";
    this.mode = mode;
  }

  async onAddToCart() {
    if (this.mode === "3d") {
      await this.addToCartWithoutUpdate();
    } else {
      (this.$refs.visualCustomization as any).addToCart();
    }
  }

  async addToCartWithoutUpdate() {
    const [data, error] = await easync(
      addToCart(this.product.externalId, 1, this.productCustomization?.uuid)
    );
    if (data) {
      this.goToCartPageWithoutUpdate();
    } else {
      console.error("Could not add to the cart", error);
    }
  }

  async goToCartPageWithoutUpdate() {
    const lang = currentUserStore.lang;
    localStorage.removeItem("ilmyo_customizer");
    window.location.assign(`${STORE_URL}/${lang}/${CART_SLUG}/`);
  }

  goToCart() {
    if (this.mode === "3d") {
      this.goToCartPageWithoutUpdate();
    } else {
      (this.$refs.visualCustomization as any).goToCart();
    }
  }
}
